// Centralized feature flags with safe defaults (all off)
// Toggle via environment variables without breaking runtime.
// Frontend env vars should start with REACT_APP_*

const boolFromEnv = (val, def = false) => {
  if (val == null) return def;
  const s = String(val).trim().toLowerCase();
  return s === '1' || s === 'true' || s === 'yes' || s === 'on';
};

export const featureFlags = {
  // Rebuilt on edge-api/Neon for V2/V3.
  referral_attribution_v1: true,
  username_claim_beta: true,
  public_profile_u: true,
  qr_codes: boolFromEnv(process.env.REACT_APP_FF_QR_CODES, false),
  /** Door / experience feedback → POST /venue-feedback (edge API). Off only if you set REACT_APP_FF_VENUE_FEEDBACK_V1=0 */
  venue_feedback_v1: boolFromEnv(process.env.REACT_APP_FF_VENUE_FEEDBACK_V1, true),
  /** Bill / receipt notes → venue_feedback with outcome bill_photo (on by default). */
  bill_upload_v1: boolFromEnv(process.env.REACT_APP_FF_BILL_UPLOAD_V1, true),
  // Modern profile layout is now the guaranteed default
  profile_layout_modern: true,
  // Backward-compat alias so any leftover references still behave the same
  profile_v2_layout: true,
  verification_modal_v1: boolFromEnv(process.env.REACT_APP_FF_VERIFICATION_MODAL_V1, false),
  fswipe_prefs_modal_v1: boolFromEnv(process.env.REACT_APP_FF_FSWIPE_PREFS_MODAL_V1, false),
  /** Sent-requests (FridaySwipe-era) in slide-out Activity — off for lean V2 */
  slideout_sent_requests: boolFromEnv(process.env.REACT_APP_FF_SLIDEOUT_SENT_REQUESTS, false),
  analytics_v1: boolFromEnv(process.env.REACT_APP_FF_ANALYTICS_V1, false),
};

// Radar trust policy:
// Keep Instagram as the only active manual verification path for now.
// LinkedIn and Phone OTP are intentionally disabled until we rebuild the
// unified trust/badge flow cleanly in V2.
export const radarVerificationPolicy = {
  instagram: true,
  linkedin: false,
  phoneOtp: false,
};

export default featureFlags;
